import { render, staticRenderFns } from "./HistoMov.vue?vue&type=template&id=c97a34fc&scoped=true"
import script from "./HistoMov.vue?vue&type=script&lang=js"
export * from "./HistoMov.vue?vue&type=script&lang=js"
import style0 from "./HistoMov.vue?vue&type=style&index=0&id=c97a34fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c97a34fc",
  null
  
)

export default component.exports